import { MarketingExpenseSnapshot } from '@/components/Approval/@components/MarketingExpense';
import { getMarketingInternalOrderNumber } from '@/utils/approval/marketingExpense';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 212 마케팅 비용 — 저장 content 그대로 + 내부 오더(레거시 조회와 동일) */
const MarketingExpenseSlot = ({ data }: ContentExtraProps) => {
  const content = (data.attributes as { content?: unknown } | null)?.content;
  if (typeof content !== 'string' || !content.trim()) return null;
  return (
    <ContentSlotRoot>
      <MarketingExpenseSnapshot
        content={content}
        internalOrderNumber={getMarketingInternalOrderNumber(data.attributes)}
      />
    </ContentSlotRoot>
  );
};

export default MarketingExpenseSlot;
